export class CreateBackupPolicyResponse {
    'backupPolicy';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicy",
            "baseName": "backupPolicy",
            "type": "BackupPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateBackupPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
